import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import moment from 'moment'
import { Query } from 'react-apollo'
import { setUIState, containerIds } from 'redux/modules/ui'
import { PAGE_QUERY } from './graphql'
import SMConst from 'frontend_core/dist/constants/sm-const'

function paidySendParams(
  room_id,
  billing,
  paidyGuestData,
  paidySpaceData,
  paidyOwnerData,
) {
  return {
    amount: parseInt(billing.additional_paidy_charge_amount_for_change),
    currency: 'JPY',
    store_name: 'Space Market',
    buyer: {
      email: paidyGuestData.email,
      name1: paidyGuestData.contactName,
      phone: paidyGuestData.verifiedTel,
    },
    buyer_data: {
      age: paidyGuestData.numberOfDaysFromRegister,
      order_count: paidyGuestData.completeReservationCountExceptPaidy,
      ltv: paidyGuestData.ltvExceptPaidy,
      last_order_amount:
        paidyGuestData.completeLastReservationPayAmountExceptPaidy,
      last_order_at: paidyGuestData.dayOfLastCompleteReservationExceptPaidy,
      //--- 拡張型BuyerData CtoC ---//
      buyer_id: paidyGuestData.id,
      shops: [
        {
          age: paidyOwnerData.numberOfDaysFromRegister,
          transaction_count: paidyOwnerData.completeReservationCountExceptPaidy,
          contact_name_kanji: paidyOwnerData.contactName,
          contact_name_katakana: paidyOwnerData.contactNameKana,
          shop_id: paidySpaceData.id,
          category: paidySpaceData.spaceTypeText,
          item_id: [room_id],
          address: {
            zip: paidySpaceData.postalCodeText,
            state: paidySpaceData.stateText,
            city: paidySpaceData.city,
            line1: paidySpaceData.address1,
            line2: paidySpaceData.address2,
          },
        },
      ],
    },
    order: {
      items: [
        {
          quantity: 1,
          unit_price:
            parseInt(billing.additional_paidy_charge_amount_for_change) -
            parseInt(
              billing.additional_paidy_charge_sales_tax_amount_for_change,
            ),
        },
      ],
      tax: parseInt(
        billing.additional_paidy_charge_sales_tax_amount_for_change,
      ),
    },
  }
}

const PaidyCharge = props => (
  <Query
    query={PAGE_QUERY}
    ssr={false}
    variables={{
      roomId: props.roomId,
      rentType:
        props.rentType === SMConst.RentType.DayTime ? 'DAY_TIME' : 'STAY',
    }}
  >
    {({ loading, error, data }) => {
      if (!!loading || !!error || !data) return null
      const paidyGuestData = data.viewer
      const paidySpaceData = data.room.space
      const paidyOwnerData = data.room.owner
      let config = {
        api_key: props.config.PAIDY_PUBLIC_KEY,
        closed: callbackData => {
          if (callbackData.status == 'authorized') {
            props.onPaidyChargeSuccess(callbackData.id, callbackData.amount)
          } else if (callbackData.status == 'rejected') {
            // 承認されなかった場合
            props.onPaidyChargeFailed()
          } else {
            // 処理中断
            props.onPaidyChargeClose()
          }
        },
      }
      const paidyHandler = Paidy.configure(config)
      const payload = paidySendParams(
        props.roomId,
        props.billing,
        paidyGuestData,
        paidySpaceData,
        paidyOwnerData,
      )
      paidyHandler.launch(payload)

      return null
    }}
  </Query>
)

function mapStateToProps(state) {
  return {
    ui: state.ui,
    config: state.config,
  }
}
function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = {
    setUIState,
  }
  return { actions: bindActionCreators(bindActions, dispatch) }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PaidyCharge)



// WEBPACK FOOTER //
// ./src/containers/organisms/PaidyCharge/index.js